import CIconButton from './CIconButton.vue';

export default CIconButton;
